import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleChart } from './google-chart.component';
import {
    FileDropDirective,
    FileSelectDirective,
    FileUploadModule
} from 'ng2-file-upload';
import { CreateAccountComponent } from '../reports/myReports/create-account/create-account.component';
import { NouisliderModule } from 'ng2-nouislider/src/nouislider';
import { ThrottleClickDirective } from './throttle-click.directive';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BackendTranslateService } from './backend-translate.service';
import { InfoTextComponent, InfoTextTemplateComponent } from './info-text/info-text.component';



import {OverlayModule} from '@angular/cdk/overlay';
import { HelperService } from './helper.service';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@Pipe({ name: 'keys', pure: false })
export class KeysPipe implements PipeTransform {
    transform(value: any, args: any[]): any {
        if (value) {
            return Object.keys(value);
        }
    }
}

@NgModule({
    imports: [
        CommonModule,
        FileUploadModule,
        NouisliderModule,
        OverlayModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    declarations: [
        GoogleChart,
        CreateAccountComponent,
        KeysPipe,
        ThrottleClickDirective,
        InfoTextComponent,
        InfoTextTemplateComponent
    ],
    exports: [
        GoogleChart,
        FileDropDirective,
        FileSelectDirective,
        CreateAccountComponent,
        KeysPipe,
        NouisliderModule,
        ThrottleClickDirective,
        InfoTextComponent,
    ],
    providers: [BackendTranslateService, HelperService],
    entryComponents: [InfoTextTemplateComponent]
})
export class HelperModule {}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/helper.module.ts